import React from 'react';
import {inputStyles, selectStyles} from '../styles';

interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  /** Message d'aide affiché sous le champ (compteur, contrainte…). */
  helper?: string;
  invalid?: boolean;
  disabled?: boolean;
  width?: number | string;
}

export const TextInput = ({
  value,
  onChange,
  label,
  placeholder = 'Placeholder',
  required = false,
  helper,
  invalid = false,
  disabled = false,
  width = '100%',
}: TextInputProps) => (
  <div style={{...inputStyles.container, width}}>
    {label && (
      <label style={selectStyles.label}>
        {label}
        {required && <span style={selectStyles.required}>*</span>}
      </label>
    )}
    <input
      type="text"
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onChange={event => onChange(event.target.value)}
      style={{
        ...inputStyles.field,
        ...(invalid ? inputStyles.fieldInvalid : {}),
        ...(disabled ? inputStyles.fieldDisabled : {}),
      }}
    />
    {helper && (
      <span style={invalid ? inputStyles.helperInvalid : inputStyles.helper}>
        {helper}
      </span>
    )}
  </div>
);

export default TextInput;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/QuestionBonus/components/TextInput.tsx